export default __webpack_public_path__ + "static/media/error-robotdown.ee4685c4.png";